<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_4"></a>Text copyright © 2019 by Josef Centeno and Betty Hallock.<br/>Photographs copyright © 2019 by Ren Fuller.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 978-1-4521-5685-9 (epub, mobi)</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN 978-1-4521-5586-9 (hardcover)</p>
<p>Prop styling by <span class="font1">ALICIA BUSZCZAK</span>.<br/>Food styling by <span class="font1">JOSEF CENTENO</span>.<br/>Design by <span class="font1">VANESSA DINA</span>.<br/>Typesetting by <span class="font1">FRANK BRAYTON</span>.</p>
<p>Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at <a href="mailto:corporatesales@chroniclebooks.com">corporatesales@chroniclebooks.com</a> or at 1-800-759-0190.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank"><span class="font1">WWW.CHRONICLEBOOKS.COM</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?fcf91938